import React, { useState } from 'react';
import T from 'prop-types';

import ExportTypeSelectionModal from '../Modals/ExportTypeSelectionModal';
import Tooltip from '../../../Tooltip';
import Button from '../../../Buttons/Button';

const FormActions = ({
  formMode,
  isSubmitDisabled = false,
  isSaveDisabled = false,
  noCrossAppsPairsSelected = false,
  isScheduled = false,
  scheduleLimitReached = false,
  allowSchedulingProgress = false,
  isModal,
  onSubmit,
  onOpenModalConfirm,
  onOpenNameModal,
  onOpenSaveModal,
  onOpenScheduleModal,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const renderGenerateButton = ({ ctaText = 'Generate Export', generateAction }) => (
    <Tooltip
      content={
        isSubmitDisabled &&
        noCrossAppsPairsSelected &&
        'Please select at least one app pairing for your Cross-App Datapoints'
      }
      wrapChildrenInHtmlNode
    >
      <Button disabled={isSubmitDisabled} onClick={generateAction}>
        {ctaText}
      </Button>
    </Tooltip>
  );

  return (
    <>
      <div className="global-upsert-export-modal__footer-buttons">
        {allowSchedulingProgress ? (
          <>
            {formMode === 'update' &&
              renderGenerateButton({
                ctaText: 'Update Export',
                generateAction: () => {
                  if (isScheduled) onOpenScheduleModal();
                  else onSubmit({ action: 'update', should_redirect: !isModal });
                },
              })}
            {formMode === 'create' &&
              renderGenerateButton({
                generateAction: () => setModalOpen(true),
              })}
          </>
        ) : (
          <>
            {formMode === 'update' &&
              renderGenerateButton({
                generateAction: onOpenModalConfirm,
              })}
            {formMode === 'create' && (
              <>
                {renderGenerateButton({
                  generateAction: () =>
                    onSubmit({ action: 'create', one_time: true, should_redirect: !isModal }),
                })}
                <Tooltip
                  content={
                    (isSubmitDisabled || isSaveDisabled) &&
                    "Advanced export settings cannot be saved during your trial period. You can continue with a one-time export by using the 'Generate Export'"
                  }
                  wrapChildrenInHtmlNode
                >
                  <Button
                    variant="secondary"
                    disabled={isSubmitDisabled || isSaveDisabled}
                    onClick={onOpenNameModal}
                  >
                    Generate & Save Export Settings
                  </Button>
                </Tooltip>
              </>
            )}
          </>
        )}
      </div>

      {isModalOpen && (
        <ExportTypeSelectionModal
          open={isModalOpen}
          isSaveDisabled={isSaveDisabled}
          isScheduled={isScheduled}
          scheduleLimitReached={scheduleLimitReached}
          onOneTimeSelect={() => {
            setModalOpen(false);
            onSubmit({ action: 'create', one_time: true, should_redirect: !isModal });
          }}
          onExportAndSaveSelect={() => {
            setModalOpen(false);
            onOpenSaveModal();
          }}
          onScheduleSelect={() => {
            setModalOpen(false);
            onOpenScheduleModal();
          }}
          onScheduleUpdateSelect={() => {
            setModalOpen(false);
            onOpenScheduleModal();
          }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};

FormActions.propTypes = {
  formMode: T.string,
  isSubmitDisabled: T.bool,
  onSubmit: T.func.isRequired,
  isSaveDisabled: T.bool,
  isModal: T.bool,
  noCrossAppsPairsSelected: T.bool,
  isScheduled: T.bool,
  scheduleLimitReached: T.bool,
  allowSchedulingProgress: T.bool,
  onOpenModalConfirm: T.func.isRequired,
  onOpenNameModal: T.func.isRequired,
  onOpenSaveModal: T.func.isRequired,
  onOpenScheduleModal: T.func.isRequired,
};

export default FormActions;
